import {inject, Injectable} from "@angular/core";
import {BokkzWageDataService} from "./bokkz-wage-data-service";
import {
  BokkzSalarisClient,
  WerkgeverEntity,
  WerknemerEntity
} from "./api.bokkz.salaris";

@Injectable({providedIn: 'root'})
export class BokkzWageLogic {

  private bokkzClient = inject(BokkzSalarisClient);
  private dataService = inject(BokkzWageDataService);

  public postWerknemerEntity(clientId: string, wn: WerknemerEntity) {
    this.bokkzClient.postOneEmployee(clientId, wn).subscribe((werknemer) => {
      this.dataService.updateWerknemer(werknemer);
    });
  }

  public postCalculationRequest(clientId: string, periode: string, jaar: string, werkgeverEntity: WerkgeverEntity) {
    this.bokkzClient.postOneCalculationRequest(clientId, periode, jaar, werkgeverEntity).subscribe((value) => {
      this.dataService.updateLoonJournaal(value);
    });
  }
}
